import React, { useEffect, useRef, useState } from 'react';
import './Flash.css';
import { Toast } from 'primereact/toast';
import Bus from '../../../Utils/Bus';

function Flash() {
  const [visibility, setVisibility] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');

  const toast = useRef(null);

  useEffect(() => {
    Bus.addListener('flash', ({ message, type }) => {
      setVisibility(true);
      setMessage(message);
      setType(type);
    });
  }, []);

  // Show toast message when visibility changes
  useEffect(() => {
    if (visibility && toast.current) {
      toast.current.show({
        severity: type,
        summary:
          type === 'error'
            ? 'Error'
            : type === 'success'
            ? 'Success'
            : 'Information',
        detail: message,
        life: 5000,
        closable: true,
        onHide: () => setVisibility(false),
      });
    }
  }, [visibility, type, message]);

  return <Toast ref={toast} position='top-center' className='flash-message' />;
}
export default Flash;
